import React from 'react'

/**
 * GlassContainer - Core glassmorphism container component
 * Provides consistent glass styling across the application
 */
const GlassContainer = ({ 
  children, 
  variant = 'default', 
  className = '', 
  ...props 
}) => {
  const variants = {
    default: 'glass-container',
    subtle: 'glass-subtle',
    prominent: 'glass-prominent',
    card: 'glass-card'
  }

  const baseClasses = variants[variant] || variants.default
  const combinedClasses = `${baseClasses} ${className}`.trim()

  return (
    <div className={combinedClasses} {...props}>
      {children}
      <div className="glass-stroke" />
    </div>
  )
}

export default GlassContainer
